import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SuccessAlert } from "wbm-generic-components";

export interface IAddToCartProviderProps {
  hasItemAgreements: boolean;
  checkoutAppUri: string;
  isLoggedIn: boolean;
  preLoadedLoginUrl: string;
}

const ClientProvider = React.lazy(
  () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "slide-outs" */
      "./AddToCartProviderClient"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as unknown as Promise<{ default: ComponentType<any> }>
);

export const AddToCartProvider = (props: IAddToCartProviderProps) => {
  const ErrorFallbackRender = (fallbackProps: FallbackProps): JSX.Element => {
    return (
      <SuccessAlert
        timerLengthInMS={3500}
        danger
        dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
        dangerAttentionText="An error has occurred!"
        onClickClose={fallbackProps.resetErrorBoundary}
      />
    );
  };

  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <ErrorBoundary fallbackRender={ErrorFallbackRender}>
          <Suspense fallback={<></>}>
            <ClientProvider {...props} />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
};

export default AddToCartProvider;
